/********************************************************************************
 * Copyright (c) 2024 Axon Ivy AG and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

.grid-background .sprotty-graph,
.grid-background.sprotty-graph {
    --grid-stroke-width: calc(1px * var(--grid-background-zoom));
    --grid-stroke-width-half: calc(var(--grid-stroke-width) / 2);
    --grid-color: rgba(0, 0, 0, 0.1);
    background-image:
        linear-gradient(to right, var(--grid-color) var(--grid-stroke-width), transparent var(--grid-stroke-width)),
        linear-gradient(to bottom, var(--grid-color) var(--grid-stroke-width), transparent var(--grid-stroke-width));
    background-size: var(--grid-background-width) var(--grid-background-height);
    background-position: calc(var(--grid-background-x) - var(--grid-stroke-width-half))
        calc(var(--grid-background-y) - var(--grid-stroke-width-half));
}
